module.exports = __webpack_public_path__ + "media/images/topics/topics-grid-bg-inc-d10f1c2d5eca0468b949bbe4fa8155b2.png";